// extracted by mini-css-extract-plugin
module.exports = {"color":"#c4c4c4","searchHeight":"28","searchIconSize":"20","goscontainer":"AppPageHeader_goscontainer_2gmYh"};